import { createContext } from "react";
import { HeaderCollection } from "./HeaderMenuTypes";

export const HeaderMenuContext = createContext<{
  headerCollections: HeaderCollection[];
}>({
  headerCollections: [],
});
